import { Database, FileCode2, TerminalSquare, ScrollText, Menu } from 'lucide-react';
import { useMobileStore, type MobileTab } from '@/stores/mobile-store';

const TABS: { id: MobileTab; icon: typeof Database; label: string }[] = [
  { id: 'connections', icon: Database, label: 'Data' },
  { id: 'query', icon: FileCode2, label: 'Query' },
  { id: 'terminal', icon: TerminalSquare, label: 'Terminal' },
  { id: 'logs', icon: ScrollText, label: 'Logs' },
  { id: 'more', icon: Menu, label: 'More' },
];

export function MobileTabBar() {
  const activeTab = useMobileStore((s) => s.activeTab);
  const setActiveTab = useMobileStore((s) => s.setActiveTab);

  return (
    <div
      className="flex border-t flex-shrink-0"
      style={{
        backgroundColor: 'var(--dbgo-sidebar)',
        borderColor: 'var(--border-default)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {TABS.map(({ id, icon: Icon, label }) => {
        const active = activeTab === id;
        return (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2"
          >
            <Icon
              size={22}
              className={active ? 'text-accent-blue' : 'text-text-muted'}
            />
            <span
              className={`text-[10px] leading-tight ${
                active ? 'text-accent-blue font-medium' : 'text-text-muted'
              }`}
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
